module.exports = __webpack_public_path__ + "static/img/PC-4.4f04e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-4.png
// module id = Ai5A
// module chunks = 0